import { Component, OnInit } from '@angular/core';

import { contasContabeisModuleName, contaContabilCodigoMask } from "../shared/data.service";
import { ContaContabil } from "../shared/conta-contabil.model";
import { ContaContabilApiService } from "../shared/conta-contabil-api.service";
import { ContaContabilNavigationService } from "../shared/conta-contabil-navigation.service";
import { FilterService } from "../../../shared/services/filter.service";
import { UtilService } from "../../../shared/services/util.service";
import { ContaContabilService } from "../shared/conta-contabil.service";

@Component({
  template: require('./conta-contabil-list.component.html')
})

export class ContaContabilListComponent implements OnInit {
  contaContabilModuleName: string = contasContabeisModuleName;
  list: Array<ContaContabil> = [];
  listClone: Array<any> = [];
  showDisabled: boolean = false;
  loading: boolean = true;
  codigoMask: number = contaContabilCodigoMask;
  count: number = 0;
  listFilter: any;

  constructor(
    private _contaContabilApiService: ContaContabilApiService,
    private _contaContabilNavigationService: ContaContabilNavigationService,
    private _contaContabilService: ContaContabilService,
    private _filterService: FilterService,
    private _utilService: UtilService
  ){}

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._contaContabilService.clearSessionStorage();
    this._contaContabilNavigationService.goToNew();
  }

  clickEdit(item: ContaContabil) {
    this._contaContabilService.clearSessionStorage();
    this._contaContabilNavigationService.goToEdit(item.id);
  }

  clickDelete(item: ContaContabil) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.listClone = Response;

        var list = filterChildren(Response);

        list.forEach(function(ll: any) {
          ll.labels = getLabels(ll);
        });

        this.list = list;
      }
      this.loading = false;
    }.bind(this));

    this._contaContabilApiService.onGetAll(onDone);

    function removeChildren(subcontas: any[], list: any) {
      var x: any, lenX: any, descricoesParaFiltrar: any[] = [];

      subcontas.forEach(function(vv) {
        for (x = 0, lenX = list.length; x < lenX; x++) {
          if (list[x].id === vv.id) {
            descricoesParaFiltrar.push(vv.descricao);
            descricoesParaFiltrar.push(vv.codigo);
            list.splice(x, 1);
            break;
          }
        }
      });

      list.push(descricoesParaFiltrar);
      return list;
    }

    var filterChildren = (function(subcontas: any) {
      var itemId: string, subcontas2: any[], list2: any[], lastPosition: number, labels: any[] = [];

      subcontas.forEach(function(item: any) {
        itemId = item.id.toString();
        subcontas2 = this._filterService.filterArray(this.listClone, itemId, ['paiId']);

        list2 = removeChildren(subcontas2, this.listClone);
        lastPosition = list2.length - 1;
        labels.push(list2[lastPosition]);
        list2.splice(lastPosition, 1);

        this.listClone = list2;

        subcontas2 = filterChildren(subcontas2);

        item.contas = subcontas2;
        item.labels = labels;
      }.bind(this));

      return subcontas;
    }.bind(this));

    function getLabels(ll: any) {
      var labels: any[] = [];
      var labels2: any[] = [];

      ll.contas.forEach(function (nn1: any) {
        labels.push(nn1.descricao);
        labels.push(nn1.codigo);
        nn1.contas.forEach(function (nn2: any) {
          labels.push(nn2.descricao);
          labels.push(nn2.codigo);
          nn2.contas.forEach(function (nn3: any) {
            labels.push(nn3.descricao);
            labels.push(nn3.codigo);
            nn3.contas.forEach(function (nn4: any) {
              labels.push(nn4.descricao);
              labels.push(nn4.codigo);
              nn4.contas.forEach(function (nn5: any) {
                labels.push(nn5.descricao);
                labels.push(nn5.codigo);
                nn5.contas.forEach(function (nn6: any) {
                  labels.push(nn6.descricao);
                  labels.push(nn6.codigo);
                  nn6.contas.forEach(function (nn7: any) {
                    labels.push(nn7.descricao);
                    labels.push(nn7.codigo);
                    nn7.contas.forEach(function (nn8: any) {
                      labels2.push(nn8.descricao);
                      labels2.push(nn8.codigo);
                      nn8.labels = labels;
                    });
                    nn7.labels = labels;
                  });
                  nn6.labels = labels;
                });
                nn5.labels = labels;
              });
              nn4.labels = labels;
            });
            nn3.labels = labels;
          });
          nn2.labels = labels;
        });
        nn1.labels = labels;
      });

      return labels;
    }
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._contaContabilApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil-list/conta-contabil-list.component.ts
 **/